var pa2 = "/static/816d50cf0cb8daf0.png";

export { pa2 as default };
//# sourceMappingURL=pa_2.png.js.map
